// extracted by mini-css-extract-plugin
export default {"marketplace":"Main_marketplace__7XEU3","marketplace__container":"Main_marketplace__container__pQL6o"};